
export function getRoutePath(route, params = {}) {
    if (typeof params !== 'object') {
        return route.replace(':id',params);
    }
    for(let param in params) {
        route = route.replace(':' + param,params[param]);
    }
    return route;
}